// extracted by mini-css-extract-plugin
export default {"open-link":"LinkText_open-link__27v7O"};